module.exports = __webpack_public_path__ + "kudos_42.svg?c1b2d43e874d224c3573ecc733bfd3a6";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kudos/kudos_42.svg
// module id = 142
// module chunks = 0